<template>

  <v-card class="rounded-l">
    <v-card-title class="primary white--text grad">
      {{ staff.user.name_first }} {{ staff.user.name_last }}
    </v-card-title>
    <v-card-subtitle class="primary white--text grad">
      {{ staff.user.job_description }} desctipion
    </v-card-subtitle>
    <v-card-text class="pa-4">
      <v-list>
        <v-list-item>
          <v-list-item-icon><v-icon color="primary">mdi-account</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ staff.user.username }}</v-list-item-title>
            <v-list-item-subtitle>
              <span>username</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon><v-icon color="primary">mdi-email</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              <div v-if="staff.user.email">{{ location.email }}</div>
              <div><a>Update</a></div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon><v-icon color="primary">mdi-phone</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              <span v-if="staff.user.phone">{{ staff.user.phone }}</span>
              <span v-else class="font-italic">Not recorded</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon><v-icon color="primary">mdi-shield</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Security</v-list-item-title>
            <v-list-item-subtitle>
              <a>Reset Password</a>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

      </v-list>

    </v-card-text>

    <v-card-actions class="">
      <v-spacer />
    </v-card-actions>

  </v-card>

</template>

<style lang="scss" scoped>
.grad{
  background: linear-gradient(90deg,rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%);
}

</style>

<script>
//import { mapActions, mapGetters } from 'vuex'
//import Moment from '@/components/Moment'

export default {
  name: 'staff',

  components: {
  },

  props: {
    staff: { type: Object, required: true },
  },

  data: () => ({
  }),

  computed: {
  },

  watch:{
  },

  methods: {
  },

  mounted() {
  }
};
</script>
7